import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgPillBottle = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M9.91675 20.125C9.91675 20.4565 10.0484 20.7745 10.2829 21.0089C10.5173 21.2433 10.8352 21.375 11.1667 21.375H18.6667C18.9983 21.375 19.3162 21.2433 19.5506 21.0089C19.7851 20.7745 19.9167 20.4565 19.9167 20.125V6.375H9.91675V11.375"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.5417 6.375H9.29175C9.12599 6.375 8.96702 6.30915 8.84981 6.19194C8.7326 6.07473 8.66675 5.91576 8.66675 5.75V3.875C8.66675 3.54348 8.79844 3.22554 9.03286 2.99112C9.26728 2.7567 9.58523 2.625 9.91675 2.625H19.9167C20.2483 2.625 20.5662 2.7567 20.8006 2.99112C21.0351 3.22554 21.1667 3.54348 21.1667 3.875V5.75C21.1667 5.91576 21.1009 6.07473 20.9837 6.19194C20.8665 6.30915 20.7075 6.375 20.5417 6.375Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.29591 20.8167C5.93842 21.1742 5.45356 21.375 4.94799 21.375C4.44242 21.375 3.95756 21.1742 3.60007 20.8167C3.24258 20.4592 3.04175 19.9743 3.04175 19.4687C3.04175 18.9632 3.24258 18.4783 3.60007 18.1208L7.91674 13.8083C8.09375 13.6313 8.30389 13.4909 8.53517 13.3951C8.76645 13.2993 9.01433 13.25 9.26466 13.25C9.51499 13.25 9.76287 13.2993 9.99414 13.3951C10.2254 13.4909 10.4356 13.6313 10.6126 13.8083C10.7896 13.9853 10.93 14.1955 11.0258 14.4268C11.1216 14.658 11.1709 14.9059 11.1709 15.1562C11.1709 15.4066 11.1216 15.6545 11.0258 15.8857C10.93 16.117 10.7896 16.3272 10.6126 16.5042L6.29591 20.8167Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.75684 15.965L8.45184 18.66"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.6667 11.375H19.9167V17.625H13.6667V11.375Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgPillBottle.displayName = 'SvgPillBottle';
export default SvgPillBottle;
